<template>
    <footer :class="style.footer">
        <Container :class="style.footerContainer">
            <div :class="style.footerData">
                <div class="h2">Contact <span :class="style.smile">:)</span></div>
                
                <a aria-label="Visit Linked Profile" :class="style.link" target="_blank" rel="noopener" href="https://www.linkedin.com/in/christine-kefalianou/">
                    <span>LinkedIn</span>
                </a>
                
                <span :class="style.separator">|</span>
                
                <a aria-label="Github" :class="style.link" target="_blank" rel="noopener" href="https://github.com/ckefalianou">
                    <span>Github</span>
                </a>
                
                <span :class="style.separator">|</span>
                
                <a aria-label="Send email" 
                   :class="style.link" 
                   target="_blank" 
                   rel="noopener" 
                   :href="mailtoRef"
                   @mouseover="revealEmail"
                   @focus="revealEmail">
                   <span>Email</span>
                </a>
            </div>
            <img :class="style.badge" alt="Vue Certification" src="@/assets/images/vue-certification-100.webp" srcset="@/assets/images/vue-certification-100.webp 1x, @/assets/images/vue-certification-200.webp 2x"/>
        </Container>
    </footer>
</template>

<script setup>
    import { ref } from 'vue';
    import style from './Footer.module.scss';
    import Container from '@/components/Container/Container.vue';
    import { decodeEmail } from '@/helpers/encodeEmail.js';

    const obfuscatedEmail = 'Y2tlZmFsaWFub3VAZ21haWwuY29t'; 
    
    const mailtoRef = ref('#');

    const revealEmail = () => {
        if (mailtoRef.value === '#') {
            const clearEmail = decodeEmail(obfuscatedEmail);
            mailtoRef.value = `mailto:${clearEmail}`;
        }
    };
</script>